module.exports = __webpack_public_path__ + "img/bsms_6b_dc.594f4bc2.webp";